export default {
  install(Vue, options) {

    // Update form group state
    const updateState = node => {
      const isError = !!node.querySelector('.m-form-group__error')
      const setClass = (n, c) => isError ? n.classList.add(c) : n.classList.remove(c)
      const setClassAll = (n, c) => n.forEach ? n.forEach(x => setClass(x, c)) : setClass(n, c)

      // Form group
      setClassAll(
        node,
        'm-form-group--error'
      )

      // Input, select, textarea
      setClassAll(
        node.querySelectorAll('.a-form-control'),
        'a-form-control--error'
      )

      // File
      setClassAll(
        node.querySelectorAll('.a-form-file'),
        'a-form-file--error'
      )

      // Checkbox
      setClassAll(
        node.querySelectorAll('.a-form-checkbox'),
        'a-form-checkbox--error'
      )

      // Radio
      setClassAll(
        node.querySelectorAll('.a-form-radio'),
        'a-form-radio--error'
      )
    }

    // DOM Mutation Observer Callback
    const observer = new MutationObserver((mutationsList, observer) => {

      // Array of form group nodes list
      let nodesList = mutationsList.flatMap(x => {
        const n = x.target.closest('.m-form-group')
        return n ? [n] : []
      })

      // Remove duplicate
      nodesList = nodesList.filter((value, index, array) => array.findIndex(x => x === value) === index)

      // Quit if empty
      if (nodesList.length <= 0) return

      // Update form group state
      nodesList.forEach(x => updateState(x))
    });

    // Start observer of app Virtual DOM
    observer.observe(
      // TODO: Observe the app root HtmlElement
      document.querySelector('#app').parentNode,
      // DO NOT WATCH CLASS ATTRIBUTE
      // This observer manipulate classList, observing 
      // class attribute will cause an infinite loop.
      {
        childList: true,
        subtree: true
      }
    );

  }
}